import { countFabricsPerColor } from '../utils/utils.js'

export default function fabricsReducer(state = { ...defaultState }, action) {
  let newState = { ...state }
  switch (action.type) {
    case 'GET_FABRICS': {
      newState.fetchingFabrics = true
      newState.fetchingFabricsError = ''
      return newState
    }
    case 'GET_FABRICS_FULFILLED': {
      const { items, filteredItems } = action.payload
      const page = newState.filters?.find((filter) => filter.name === 'page')

      if (page?.value === '1') {
        newState.fabrics = items
        newState.filteredFabrics = filteredItems
      } else {
        newState.fabrics = items.reduce((acc, item) => {
          if (!acc.find((f) => f.id === item.id)) {
            acc.push(item)
          }
          return acc
        }, newState.fabrics || [])
        newState.filteredFabrics = filteredItems.reduce((acc, item) => {
          if (!acc.find((f) => f.id === item.id)) {
            acc.push(item)
          }
          return acc
        }, newState.filteredFabrics || [])
      }

      newState.fetchingFabrics = false
      newState.fetchedFabrics = true
      return newState
    }
    case 'GET_COLORS_FULFILLED': {
      const { items } = action.payload
      newState.nrOfFabricsPerColor = countFabricsPerColor(newState.colorMap, items)
      return newState
    }
    case 'GET_FABRICS_REJECTED': {
      const { err } = action
      newState.fetchingFabricsError = err
      newState.fetchingFabrics = false
      newState.fetchedFabrics = false
      return newState
    }
    case 'ADD_PRESELECTED_FABRIC': {
      const { fabric } = action.payload
      if (!(newState.fabrics || []).find((f) => f.id === fabric.id)) {
        newState.fabrics = [fabric, ...(newState.fabrics || [])]
      }
      if (!(newState.filteredFabrics || []).find((f) => f.id === fabric.id)) {
        newState.filteredFabrics = [fabric, ...(newState.filteredFabrics || [])]
      }
      return newState
    }
    case 'ADD_PRESELECTED_CORD_FABRIC': {
      const { fabric } = action.payload
      if (!(newState.cordingFabrics || []).find((f) => f.id === fabric.id)) {
        newState.cordingFabrics = [fabric, ...(newState.cordingFabrics || [])]
      }
      if (!(newState.filteredCordingFabrics || []).find((f) => f.id === fabric.id)) {
        newState.filteredCordingFabrics = [fabric, ...(newState.filteredCordingFabrics || [])]
      }
      return newState
    }
    case 'SET_FILTERED_FABRICS': {
      const { items } = action.payload
      newState.filteredFabrics = items
      return newState
    }
    case 'SET_FILTERED_CORDING_FABRICS': {
      const { items } = action.payload
      newState.filteredCordingFabrics = items
      return newState
    }
    case 'GET_BRANDS': {
      newState.fetchingBrands = true
      newState.fetchingBrandsError = ''
      return newState
    }
    case 'GET_BRANDS_FULFILLED': {
      const { items } = action.payload
      newState.brands = items
      newState.fetchingBrands = false
      newState.fetchedBrands = true
      return newState
    }
    case 'GET_BRANDS_REJECTED': {
      const { err } = action
      newState.fetchingBrandsError = err
      newState.fetchingBrands = false
      newState.fetchedBrands = false
      return newState
    }
    case 'GET_MATERIALS': {
      newState.fetchingMaterials = true
      newState.fetchingMaterialsError = ''
      return newState
    }
    case 'GET_MATERIALS_FULFILLED': {
      const { items } = action.payload
      newState.materials = items
      newState.fetchingMaterials = false
      newState.fetchedMaterials = true
      return newState
    }
    case 'GET_MATERIALS_REJECTED': {
      const { err } = action
      newState.fetchingMaterialsError = err
      newState.fetchingMaterials = false
      newState.fetchedMaterials = false
      return newState
    }
    case 'GET_USES': {
      newState.fetchingUses = true
      newState.fetchingUsesError = ''
      return newState
    }
    case 'GET_USES_FULFILLED': {
      const { items } = action.payload
      newState.uses = items
      newState.fetchingUses = false
      newState.fetchedUses = true
      return newState
    }
    case 'GET_USES_REJECTED': {
      const { err } = action
      newState.fetchingUsesError = err
      newState.fetchingUses = false
      newState.fetchedUses = false
      return newState
    }
    case 'GET_PATTERNS': {
      newState.fetchingPatterns = true
      newState.fetchingPatternsError = ''
      return newState
    }
    case 'GET_PATTERNS_FULFILLED': {
      const { items } = action.payload
      newState.patterns = items
      newState.fetchingPatterns = false
      newState.fetchedPatterns = true
      return newState
    }
    case 'GET_PATTERNS_REJECTED': {
      const { err } = action
      newState.fetchingPatternsError = err
      newState.fetchingPatterns = false
      newState.fetchedPatterns = false
      return newState
    }
    case 'SET_FILTERS': {
      const { params } = action.payload
      newState.filters = params
      return newState
    }
    case 'SET_FRONTEND_FILTERS': {
      const { params } = action.payload
      newState.frontendFilters = params
      return newState
    }
    case 'SET_FRONTEND_CORDING_FILTERS': {
      const { params } = action.payload
      newState.frontendCordingFilters = params
      return newState
    }
    case 'GET_COLOR_MAP': {
      newState.fetchingColorMap = true
      newState.fetchingColorMapError = ''
      return newState
    }
    case 'GET_COLOR_MAP_FULFILLED': {
      const { items } = action.payload
      newState.colorMap = items
      newState.fetchingColorMap = false
      newState.fetchedColorMap = true
      return newState
    }
    case 'GET_COLOR_MAP_REJECTED': {
      const { err } = action
      newState.fetchingColorsError = err
      newState.fetchingColorMap = false
      newState.fetchedColorMap = false
      return newState
    }
    case 'SET_IS_ONE_CUSTOM_ATTRIBUTE_API_FILTER_APPLIED': {
      const { value } = action.payload
      newState.isOneCustomAttributeAPIFilterApplied = value
      return newState
    }
    case 'SET_COLOR_API_FILTERS': {
      const { colors } = action.payload
      newState.colorApiFilters = colors
      return newState
    }
    case 'SET_STOCK_API_FILTERS': {
      const { stock } = action.payload
      newState.stock = stock
      return newState
    }
    case 'SET_CANCEL': {
      const { cancel } = action.payload
      newState.cancel = cancel
      return newState
    }
    case 'SET_ALL_FABRICS_FOR_KITS': {
      const { fabricsKits } = action.payload
      newState.fabricsKits = fabricsKits
      return newState
    }
    case 'SET_CORDING_FABRICS': {
      const { cordingFabrics } = action.payload
      newState.cordingFabrics = cordingFabrics
      return newState
    }
    case 'SET_CORDING_FILTERS': {
      const { params } = action.payload
      newState.cordingFilters = params
      return newState
    }
    case 'GET_CORDING_FABRICS': {
      newState.fetchingCordingFabrics = true
      newState.fetchingCordingFabricsError = ''
      return newState
    }
    case 'GET_CORDING_FABRICS_FULFILLED': {
      const { items, filteredItems } = action.payload
      const page = newState.filters?.find((filter) => filter.name === 'page')

      if (page?.value === '1') {
        newState.cordingFabrics = items
        newState.filteredCordingFabrics = filteredItems
      } else {
        newState.cordingFabrics = items.reduce((acc, item) => {
          if (!acc.find((f) => f.id === item.id)) {
            acc.push(item)
          }
          return acc
        }, newState.cordingFabrics || [])
        newState.filteredCordingFabrics = filteredItems.reduce((acc, item) => {
          if (!acc.find((f) => f.id === item.id)) {
            acc.push(item)
          }
          return acc
        }, newState.filteredCordingFabrics || [])
      }
      newState.fetchingCordingFabrics = false
      newState.fetchedCordingFabrics = true
      newState.nrOfCordingFabricsPerColor = countFabricsPerColor(newState.colorMap, items)
      return newState
    }
    case 'GET_CORDING_FABRICS_REJECTED': {
      const { err } = action
      newState.fetchingCordingFabricsError = err
      newState.fetchingCordingFabrics = false
      newState.fetchedCordingFabrics = false
      return newState
    }
    case 'UPDATE_SCROLL_POSITION': {
      newState.scrollTop = action.scrollTop
      return newState
    }
    default:
      return newState
  }
}

const defaultState = {
  fabrics: [],
  fetchingFabrics: false,
  fetchedFabrics: false,
  fetchingFabricsError: '',
  filteredFabrics: [],
  brands: [],
  fetchingBrands: false,
  fetchedBrands: false,
  fetchingBrandsError: '',
  materials: [],
  fetchingMaterials: false,
  fetchedMaterials: false,
  fetchingMaterialsError: '',
  uses: [],
  fetchingUses: false,
  fetchedUses: false,
  fetchingUsesError: '',
  patterns: [],
  fetchingPatterns: false,
  fetchedPatterns: false,
  fetchingPatternsError: '',
  colorMap: {},
  fetchingColorMap: false,
  fetchedColorMap: false,
  fetchingColorMapError: '',
  filters: [],
  colorApiFilters: [],
  frontendFilters: {
    brand: [0],
    material: [0],
    use: [0],
    pattern: [0],
    colors: [0],
    showOnlyFavourites: false,
  },
  nrOfFabricsPerColor: {},
  isOneCustomAttributeAPIFilterApplied: false,
  cancel: null,
  stock: false,
  fabricsKits: null,
  cordingFabrics: [],
  cordingFilters: [],
  fetchingCordingFabrics: false,
  fetchedCordingFabrics: false,
  fetchingCordingFabricsError: '',
  filteredCordingFabrics: [],
  nrOfCordingFabricsPerColor: {},
  frontendCordingFilters: {
    brand: [0],
    material: [0],
    use: [0],
    pattern: [0],
    colors: [0],
    showOnlyFavourites: false,
  },
  scrollTop: 0,
}
